import { useTranslation } from "react-i18next";
import { Tag } from "../../Tag/Tag";
import "../../../../../i18n/i18n";
import { colorTagProps } from "./colorTagProps";

type ConnectionStatus = "APPROVED" | "CONNECTED" | "IDLE" | "PENDING" | "REJECTED" | "REVOKED";
const connectionStatusEnum = ["APPROVED", "CONNECTED", "IDLE", "PENDING", "REJECTED", "REVOKED"];

const connectionStatusProps: Record<
  ConnectionStatus,
  (typeof colorTagProps)[keyof typeof colorTagProps]
> = {
  APPROVED: colorTagProps.success,
  CONNECTED: colorTagProps.success,
  IDLE: colorTagProps.neutral,
  PENDING: colorTagProps.informative,
  REJECTED: colorTagProps.error,
  REVOKED: colorTagProps.error,
};

export const TableTagVehicleConnectionStatus = (props: {
  connectionStatus: ConnectionStatus;
}) => {
  const { t } = useTranslation();

  const statusKey = connectionStatusEnum.find(
    (s) => t(`vehicles.connectionStatus.${s}`) === props.connectionStatus,
  ) as ConnectionStatus;

  if (!statusKey) {
    return "";
  }

  const render = connectionStatusProps[statusKey];

  return (
    props.connectionStatus && (
      <Tag
        text={props.connectionStatus}
        backgroundColor={render.backgroundColor}
        textColor={render.textColor}
        iconColor={render.iconColor}
        //iconLeft={render.iconLeft}
      />
    )
  );
};
